import React from "react";
import {useForm} from "react-hook-form";

import Pagina from "../comun/Pagina";
import MensajeValidacion from "../comun/MensajeValidacion"
import Boton from "../comun/Boton";
import mundo from '../../img/mundo.png';

const formatearFecha = (fecha)=> {    
    var dd = fecha.getDate();
    var mm = fecha.getMonth() + 1;
    var yyyy = fecha.getFullYear();

    if (dd < 10) {
        dd = '0' + dd;
    }

    if (mm < 10) {
        mm = '0' + mm;
    } 
        
    let today = yyyy + '-' + mm + '-' + dd;
    return today;
}

const anioPasado =()=> {
    let d = new Date();
    let a =d.getFullYear() -1;
    d.setFullYear(a);
    return formatearFecha(d);
}

export default function Pagina1b(props) {
    const {register, handleSubmit, watch, formState: { errors }} = useForm();   
    
    const onSubmit = (data)=>{
        props.setState(data);
        props.avanzarPaginaAlt();
    }

    return (
        <Pagina
        titulo="Reporta el sismo"
        imgSrc={mundo}
        imgAlt="Reporta el sismo"        
        handleSubmit={handleSubmit}  
        onSubmit={onSubmit}
        botonesNavegacion={<BotonesAdelanteAtras retrocederPagina={props.retrocederPaginaAlt}/>}        
        explicacion={
            <React.Fragment>
            Ingresa la fecha y hora en que sentiste el sismo.
            </React.Fragment>
        }
        
        contenidoPrincipal= {
            <React.Fragment>
            <div>
            <div>
                <div className="TextoMedianoVerde">¿En qué fecha percibiste el sismo?</div>
                <input type="date" name="fechaSismoAlterna" min={anioPasado()} max={formatearFecha(new Date())} 
                {...register("fechaSismoAlterna", {required:true})}></input>
                <MensajeValidacion nombre="fechaSismoAlterna" errors={errors}/>
            </div> 
            <div>
                <div className="TextoMedianoVerde">¿A qué hora lo sentiste?</div>
                <input type="time" name="horaSismoAlterna" {...register("horaSismoAlterna", {required:true})}></input>
                <MensajeValidacion nombre="horaSismoAlterna" errors={errors}/>
            </div>
            </div> 
            </React.Fragment>        
        }
        />
    );
}

const BotonesAdelanteAtras = ({retrocederPagina}) => {
    return (        
        <div>        
            <Boton texto="Anterior" onClick={retrocederPagina} />
            &nbsp;              
            <Boton texto="Siguiente" tipo="submit" />
        </div>
    )
}